import TabPage from "./../../factories/tab-page";
import "./../../bindings/bao-searcher";
import "./../../bindings/bao-date-time-box";
import "./../../bindings/bao-date-time-picker";
import * as $ from "jquery";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialog from "./../../factories/bao-dialog";
import baoRouter from "./../../services/bao-router";
import * as moment from "moment";
class SummaryReportModel {
    Bao = Bao;
    Parent;
    TabPage: TabPage;
    Color: string = "text-primary";
    Icon: string = "fal fa-layer-group";
    Sort: number = 120;
    SummaryReportFilterId: KnockoutObservable<string> = ko.observable();
    SummaryReportFilterName: KnockoutObservable<string> = ko.observable();
    ValidDate: KnockoutObservable<string> = ko.observable();
    SummaryReportFilter: KnockoutObservable<any> = ko.observable();
    FilterInterval: KnockoutObservable<number> = ko.observable();
    FilterIntervalKey: KnockoutObservable<string> = ko.observable();
    IsIndividually: KnockoutObservable<boolean> = ko.observable(false);
    FilterPeriodTo: KnockoutObservable<string> = ko.observable();
    Columns: KnockoutObservableArray<any> = ko.observableArray();
    Infos: KnockoutObservableArray<any> = ko.observableArray();
    PageIndex: KnockoutObservable<number> = ko.observable(0);
    PageSize: KnockoutObservable<number> = ko.observable(20);
    TotalRows: KnockoutObservable<number> = ko.observable(0);
    Sorting: KnockoutObservableArray<{
        Column: string;
        Direction: number;
    }> = ko.observableArray([]);
    Selection: KnockoutObservableArray<any> = ko.observableArray();
    CustomFilter: KnockoutObservable<any> = ko.observable({});
    IsFavorite: KnockoutObservable<boolean> = ko.observable(false);
    private intervalForward = () => {
        this.switchInterval();
    };
    private intervalBackward = () => {
        this.switchInterval(true);
    };
    private switchInterval = (switchBack?: boolean) => {
        if (this.ValidDate()) {
            let filterInterval = this.FilterInterval();
            if (!filterInterval) {
                filterInterval = 1;
            }
            if (switchBack) {
                filterInterval = -filterInterval;
            }
            switch (this.FilterIntervalKey()) {
                case "Week":
                    this.ValidDate(moment(this.ValidDate(), Bao.Utils.DateTimeFormat).add(filterInterval, "w").format(Bao.Utils.DateTimeFormat));
                    break;
                case "Month":
                    this.ValidDate(moment(this.ValidDate(), Bao.Utils.DateTimeFormat).add(filterInterval, "M").format(Bao.Utils.DateTimeFormat));
                    break;
                case "Year":
                    this.ValidDate(moment(this.ValidDate(), Bao.Utils.DateTimeFormat).add(filterInterval, "y").format(Bao.Utils.DateTimeFormat));
                    break;
                default:
                    this.ValidDate(moment(this.ValidDate(), Bao.Utils.DateTimeFormat).add(filterInterval, "d").format(Bao.Utils.DateTimeFormat));
                    break;
            }
        }
    };
    private CalculateEndDate(): string {
        let filterInterval = this.FilterInterval();
        if (!filterInterval) {
            filterInterval = 1;
        }
        switch (this.FilterIntervalKey()) {
            case "Week":
                return (moment(this.ValidDate(), Bao.Utils.DateTimeFormat).add(filterInterval, "w").add(-1, 'm').format(Bao.Utils.DateTimeFormat));
            case "Month":
                return (moment(this.ValidDate(), Bao.Utils.DateTimeFormat).add(filterInterval, "M").add(-1, 'm').format(Bao.Utils.DateTimeFormat));
            case "Year":
                return (moment(this.ValidDate(), Bao.Utils.DateTimeFormat).add(filterInterval, "y").add(-1, 'm').format(Bao.Utils.DateTimeFormat));
            case "Individually":
                if (this.FilterPeriodTo == null) {
                    return (moment(this.ValidDate(), Bao.Utils.DateTimeFormat).add(1, "d").add(-1, 'm').format(Bao.Utils.DateTimeFormat));
                }
                return this.FilterPeriodTo();
            default:
                return (moment(this.ValidDate(), Bao.Utils.DateTimeFormat).add(filterInterval, "d").add(-1, 'm').format(Bao.Utils.DateTimeFormat));
        }
    }
    DateTimeBoxValidDate: Bindings.baoDateTimeBox = {
        value: this.ValidDate,
        mode: 'date',
        culture: Bao.Session.Language.Symbol()
    };
    DateTimeBoxValidDateIndividually: Bindings.baoDateTimeBox = {
        value: this.ValidDate,
        mode: 'datetime',
        culture: Bao.Session.Language.Symbol()
    };
    DateTimeBoxFilterPeriodTo: Bindings.baoDateTimeBox = {
        value: this.FilterPeriodTo,
        mode: 'datetime',
        culture: Bao.Session.Language.Symbol()
    };
    DateTimePickerValidDate: Bindings.baoDateTimePicker = {
        mode: 'date',
        showNavigation: true,
        backward: this.intervalBackward,
        forward: this.intervalForward
    };
    DateTimePickerValidDateIndividually: Bindings.baoDateTimePicker = {
        mode: 'datetime',
    };
    DateTimePickerFilterPeriodTo: Bindings.baoDateTimePicker = {
        mode: 'datetime',
    };
    GotoSummaryReportFilterVisible = ko.computed(() => {
        return this.SummaryReportFilterId() != null && Bao.Session.HasPermission('SummaryReportFilterSearch', 'E08AA793-C9AD-4C68-BF21-06014EA951A3');
    });
    GoToSummaryReportFilter = () => {
        if (this.SummaryReportFilterId() != "") {
            baoRouter.setHash("#SummaryReportFilter/" + this.SummaryReportFilterId());
        }
    };
    SearcherSummaryReportFilter: Bindings.baoSearcher = {
        ObjectId: this.SummaryReportFilterId,
        ObjectValue: 'Name',
        SearchType: 'SummaryReportFilter',
        SelectedItem: this.SummaryReportFilter,
        AutoComplete: true,
        AutoSearch: true,
        CustomFilter: { CurrentUser: true },
        GotoVisible: this.GotoSummaryReportFilterVisible,
        Goto: this.GoToSummaryReportFilter
    };
    constructor(parent: any) {
        this.Parent = parent;
        this.TabPage = parent.TabPage;
        this.PageIndex.subscribe(() => {
            this.Display();
        });
        this.Sorting.subscribe(() => {
            this.Display();
        });
        this.CustomFilter.subscribe(() => {
            this.Display();
        });
        this.SummaryReportFilterId.subscribe((newValue: string) => {
            this.isQuickStartModuleActive();
        });
        this.SummaryReportFilter.subscribe(() => {
            if (this.SummaryReportFilter()) {
                this.FilterInterval(this.SummaryReportFilter().FilterInterval);
                this.FilterIntervalKey(this.SummaryReportFilter().FilterIntervalKey);
                this.IsIndividually(this.SummaryReportFilter().IsIndividually);
            }
        });
        this.ValidDate.subscribe(() => {
            this.FilterPeriodTo(this.CalculateEndDate());
        });
    }
    LoadSummaryReportFilter(id) {
        return Bao.post("SummaryReportFilter/Get", JSON.stringify({ id: id }))
            .then((serverResultModel) => {
            this.SummaryReportFilter(serverResultModel);
        });
    }
    Display = () => {
        if (!this.completeCheck()) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
            return;
        }
        this.getSummaryReportData();
    };
    link = (info: any) => {
        baoRouter.setHash('Report/' + info.ReportId + '/Info/' + info.InfoId);
    };
    private init() {
        // check if deep link is set (summaryreportfilter) and request serverinfo if so
        let initializeSummaryReportFilterDeferred = this.CheckAndLoadDeepLinkInfo();
        Bao.bindEvent('FavoriteIcon:refresh', (value) => {
            this.IsFavorite(this.IsFavorite());
        });
        return $.when(this.getSummaryReportMetadata(), initializeSummaryReportFilterDeferred);
    }
    private CheckAndLoadDeepLinkInfo() {
        let summaryReportFilterId = baoRouter.getRouteValue("param", this.TabPage);
        if (!summaryReportFilterId) {
            // no deep link info => cancel 
            return;
        }
        // load deeplinkinfo and return deferred object
        return this.LoadSummaryReportFilter(summaryReportFilterId)
            // set init fields for deeplink call
            .then(() => {
            // cancel if no SummaryReport filter is set
            if (!(this.SummaryReportFilter())) {
                return;
            }
            this.SummaryReportFilterId(this.SummaryReportFilter().SummaryReportId);
            this.SummaryReportFilterName(this.SummaryReportFilter().Name);
            this.FilterInterval(this.SummaryReportFilter().FilterInterval);
            this.FilterIntervalKey(this.SummaryReportFilter().FilterIntervalKey);
            this.IsIndividually(this.SummaryReportFilter().IsIndividually);
        });
    }
    private getSummaryReportMetadata() {
        return Bao.post("SummaryReport/GetSummaryReportMetadata")
            .then(result => {
            this.Columns(result.Columns);
            this.ValidDate(result.ValidDate);
        });
    }
    private getSummaryReportData() {
        this.TabPage.IsLoading(true);
        return Bao.post("SummaryReport/GetAll", JSON.stringify({
            summaryReportFilterId: this.SummaryReportFilterId(),
            pageIndex: this.PageIndex(),
            pageSize: this.PageSize(),
            sorting: this.Sorting(),
            customFilter: this.toHashObject(ko.unwrap(this.CustomFilter)),
            startTime: this.ValidDate(),
            endTime: this.FilterPeriodTo()
        })).then(result => {
            this.Infos(result.Infos);
            this.TotalRows(result.TotalRows);
        }).always(() => {
            this.TabPage.IsLoading(false);
        });
    }
    private toHashObject(customFilter: any) {
        var returnValue = [];
        for (var f in customFilter) {
            returnValue.push({ Key: f, Value: ko.unwrap(customFilter[f]) });
        }
        return returnValue;
    }
    ;
    private completeCheck() {
        if (this.IsIndividually()) {
            return Boolean(!Bao.Utils.String.IsNullOrEmpty(this.SummaryReportFilterId()) && !Bao.Utils.String.IsNullOrEmpty(this.ValidDate()) && !Bao.Utils.String.IsNullOrEmpty(this.FilterPeriodTo()));
        }
        return Boolean(!Bao.Utils.String.IsNullOrEmpty(this.SummaryReportFilterId()) && !Bao.Utils.String.IsNullOrEmpty(this.ValidDate()));
    }
    ;
    isQuickStartModuleActive = () => {
        return Bao.post("StartModule/IsQuickStartModuleActive", JSON.stringify({
            webUrl: this.GetSummaryFilterDeppLink()
        })).done(result => {
            this.IsFavorite(result);
        });
    };
    addQuickStartModule = () => {
        this.TabPage.IsLoading(true);
        return Bao.post("StartModule/AddQuickStartModule", JSON.stringify({
            caption1: this.SummaryReportFilterName(),
            caption2: this.SummaryReportFilterName(),
            caption3: this.SummaryReportFilterName(),
            caption4: this.SummaryReportFilterName(),
            caption5: this.SummaryReportFilterName(),
            webUrl: this.GetSummaryFilterDeppLink(),
            color: this.Color,
            icon: this.Icon,
            sort: this.Sort
        })).done(result => {
            if (result) {
                this.IsFavorite(true);
            }
            this.TabPage.IsLoading(false);
        });
    };
    removeQuickStartModuleWebUrl = () => {
        this.TabPage.IsLoading(true);
        return Bao.post("StartModule/RemoveQuickStartModuleByWebUrl", JSON.stringify({
            webUrl: this.GetSummaryFilterDeppLink()
        })).done(result => {
            if (result) {
                this.IsFavorite(false);
            }
            this.TabPage.IsLoading(false);
        });
    };
    Download = () => {
        if (!this.completeCheck()) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
            return;
        }
        var filterObjects = ["SummaryReportFilterId", "ValidDate", "FilterPeriodTo"];
        var data = {
            filter: this.Parent.GetFilterHashObject(filterObjects, this),
            sorting: this.Sorting()
        };
        // open download tab
        this.Parent.DownloadReport("SummaryReport", data);
    };
    changeFavoriteStatus = () => {
        var promise;
        if (this.IsFavorite()) {
            promise = this.removeQuickStartModuleWebUrl();
        }
        else {
            promise = this.addQuickStartModule();
        }
        promise.then(() => { Bao.raiseEvent('QuickStartModules:refresh', null); });
    };
    GetSummaryFilterDeppLink() {
        let reportid = baoRouter.getRouteValue("reportid", this.TabPage);
        return "#/reportcenter/" + reportid + "/" + this.SummaryReportFilterId();
    }
}
export default SummaryReportModel;